import { render } from "./HistoricalDateBanner.vue?vue&type=template&id=cbc2d158"
import script from "./HistoricalDateBanner.vue?vue&type=script&lang=js"
export * from "./HistoricalDateBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__